import styled from "styled-components";
import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import { setFontVariant } from "@similarweb/styles";

export const StyledArrowIcon = styled(SWReactIcons)`
    visibility: hidden;
    min-width: 12px;
    margin-left: 7px;
    svg {
        &,
        & path {
            fill: ${colorsPalettes.blue[400]};
        }
    }
`;
export const KeywordWrapper = styled.span`
    color: ${colorsPalettes.blue["400"]};
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: middle;
    display: inline-block;
`;

export const CellContainer = styled.div`
    display: flex;
    max-width: inherit;
`;

export const ArrowKeywordWrapper = styled.div`
    padding: 4px;
    border-radius: 4px;
    width: inherit;
    max-width: fit-content;
    display: flex;
    &:hover {
        cursor: pointer;
        background-color: ${colorsPalettes.blue["100"]};
        ${StyledArrowIcon} {
            visibility: visible;
        }
    }
`;

export const GoToText = styled(I18n)`
    ${setFontVariant("value", colorsPalettes.carbon["500"])};
    font-weight: 500;
    line-height: 16px;
`;
export const TxtWrapper = styled.div`
    pointer-events: none;
    margin: 17px 20px 17px 16px;
    font-weight: 500;
    line-height: 16px;
`;
